export default __webpack_public_path__ + "static/datahub-92098bb8d24e815f5a24d648d74b4836.png";